import { Component, OnDestroy, OnInit } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, AuthenticationResult } from '@azure/msal-browser';
import { filter, take } from 'rxjs/operators';
import { SoapRequestService } from '../services/soap-request.service';
import { OpenPoService } from '../services/open-po.service';
import { AppConfigService } from '../services/app.config.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ApplicationDescriptionComponent } from './application-description/application-description.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { AppAzureLoginDialogComponent } from '../app-azure-login/app-azure-login-dialog.component';
import { CommonService } from '../common.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy{
  loginDisplay = false;
  fileString="";
  applicationTiles: any[] = [];
  displayMsg:boolean = false;
  displayDisclaimer: boolean = false;
  azureUserDlts :any;
  url:any = this.appConfigService.get('applicationUrl');
  isDisclaimerAgreed:boolean = false;
  scsUserDetail: any;
  showTiles:boolean = false;
  accessDeniedMsg: any;
  itsmUrl: any;
  loggedInUserEmail:any;

  constructor(private authService: MsalService, private msalBroadcastService: MsalBroadcastService,
    private soapService: SoapRequestService,
    private openPoService: OpenPoService,
    private appConfigService: AppConfigService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private router: Router,
    private matDialog: MatDialog,
    private commonService: CommonService
    ) {
      this.spinner.show('sp1')
     }

  ngOnInit(): void {
    this.getITSMUrl();
    this.getAccessDeniedMsg();
    this.applicationTiles = this.appConfigService.get('applicationTiles');
    this.applicationTiles = this.applicationTiles?.map(app => ({
      ...app,
      showTile: JSON.parse(app.showTile) // Convert string to boolean
    }));
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
      )
      .subscribe((result: EventMessage) => {
        const payload = result.payload as AuthenticationResult;
        this.authService.instance.setActiveAccount(payload.account);
        localStorage.setItem('access_token', payload.accessToken)
        this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
      });

    this.commonService.emailSubject.subscribe(email => {
      if (email) {
        console.log("----email ---73----ngoninit", email);
        this.setLoginDisplay(email);
      }
    });
  }
  async setLoginDisplay(email: string) {
    this.openPoService.getAzureUserId(email).subscribe(async (res: any) => {

      this.scsUserDetail = res.data?.getAzureUserId;
      // const userData: any = await this.openPoService.isEmailAvailable(email).pipe(take(1)).toPromise();//rxjs version 6 (pipe(take(1)).toPromise())
      // const isUserEmailAvailableInSOB = userData?.data?.isEmailAvailable;
      const isUserEmailAvailableInSOB = true;
      console.log("--isUserEmailAvailableInSOB--", isUserEmailAvailableInSOB);

      // const userVendorResponse: any = await this.openPoService.isUserAvailableAndHasVendorCodeInSOB(email).pipe(take(1)).toPromise();//rxjs version 6 (pipe(take(1)).toPromise())
      // console.log("--isUserAvailableAndHasVendorCodeInSOB----response--------", userVendorResponse );
      // const isUserAvailableAndHasVendorCodeInSOB = userVendorResponse?.data?.isUserAvailableAndHasVendorCode;
      const isUserAvailableAndHasVendorCodeInSOB = true;

      // const userDisclaimerInfo : any = await this.openPoService.isDisclaimerAgreedByTheUserInSOB(email).pipe(take(1)).toPromise();//rxjs version 6 (pipe(take(1)).toPromise())
      // console.log("--userDisclaimerInfo-----------", userDisclaimerInfo);
      // const isDisclaimerAgreedInSOB = userDisclaimerInfo?.data?.isDisclaimerAgreedByTheUser;
      const isDisclaimerAgreedInSOB = true;

      if (!this.scsUserDetail?.length) {
        // If user details not present in SCS, checking whether userEmail, vendorCode, disclaimer is available or not in SOB user details table.
        // If both userEmail,vendorCode and disclaimer is available, tiles page will display. If not, it will redirect to SOB application.
        console.log("----121---");
        if(localStorage.getItem('azureRole')?.toLowerCase() === 'vendor') {
          if (isUserEmailAvailableInSOB) {
            if (isUserAvailableAndHasVendorCodeInSOB && isDisclaimerAgreedInSOB) {
              console.log("-----90-------");
              this.showTiles = true;
              this.spinner.hide('sp1');
              return;
            } else {
              console.log("-----100-dont have vc-not agreed-")
              // window.location.replace(this.appConfigService.get("vendorOnboarding.vobFeUrl"));
              this.spinner.hide('sp1');
              return;
            }
          } else {
            console.log("----user not present in both scs and sob-")
            this.commonService.openSnackBar("UnAuthorized user", '', 8000)
            this.spinner.hide('sp1');
            return;
          }
        } else {
            console.log("----106---non-vendor-")
            this.showTiles = true;
            this.spinner.hide('sp1');
            return;
        }
      }
      const isVendor = this.scsUserDetail?.[0]?.userRoleDtls?.roleName?.toLowerCase() === 'vendor';
      const isIndiaVendor = this.scsUserDetail?.[0]?.vendorDetails?.some((vendor: any) => vendor?.vendorCountry === 'India');
      const panStatus = localStorage.getItem('azurePanVerifyStatus')?.toLowerCase();
      console.log("---panStatus-----", panStatus);
      let shouldOpenLoginDialog = false;

      if (isVendor) {
        if (isUserEmailAvailableInSOB) {
          console.log("---user available in sob-----");
          if (isUserAvailableAndHasVendorCodeInSOB && isDisclaimerAgreedInSOB) {
            if (isIndiaVendor && panStatus !== 'success') {
              // Indian vendor and not yet verified
              shouldOpenLoginDialog = true;
              this.spinner.hide('sp1');
            } else if (!isIndiaVendor && panStatus !== 'notapplicable') {
              // Import vendor and not yet logged in
              shouldOpenLoginDialog = true;
              this.spinner.hide('sp1');
            }
          } else {
            // window.location.replace(this.appConfigService.get("vendorOnboarding.vobFeUrl"));
            this.spinner.hide('sp1');
            return;
          }
        } else {
          console.log("--vendor not present in sob--");
          shouldOpenLoginDialog = true;//vendor not present in sob
          this.spinner.hide('sp1');
        }
      }

      console.log("---shouldOpenLoginDialog--******-", shouldOpenLoginDialog);
      if (shouldOpenLoginDialog) {
        const dialog = this.matDialog.open(AppAzureLoginDialogComponent, {
          disableClose: true,
          width: '35%',
          maxWidth: '90vw',
          panelClass: 'azure-login-dialog',
          autoFocus: false,
          data: { isIndia: isIndiaVendor },
        });
        dialog.afterClosed().subscribe((res) => {
          if (res) {
            console.log("---login dialog res---163----------", res);
            this.showTiles = true;
            this.spinner.hide('sp1');
          }
        });
      } else {
        this.showTiles = true; // Already verified or already logged in or not a vendor role
        console.log("---login dialog res---170----------", res);
        this.spinner.hide('sp1');
      }
    });
  }

  async onTileClick(appDetails: any) {
    if (!appDetails || appDetails.status.toLowerCase() !== 'ready') {
      this.commonService.openSnackBar('Coming soon....', 'Ok', 5000);
    };
    const appName = appDetails.applicationName;

    if (appName === 'PO & Invoice Collaboration') {
      console.log("------SCS tile clicked-----");
      const loggedInPanNo = localStorage.getItem("panNo");
      console.log("---loggedInPanNo---", loggedInPanNo);

      this.openPoService.getAzureUserId(localStorage.getItem("email")).subscribe(async res => {
        const userDetails = res.data?.getAzureUserId;
        if (!userDetails.length) {
          console.log("---190---user details not available in scs------");
          this.showAccessDeniedSnackbar();
          return;
        }
        console.log("====userDetails?.[0]?.userRoleDtls?.roleName======", userDetails?.[0]?.userRoleDtls?.roleName);
        const isVendor = userDetails?.[0]?.userRoleDtls?.roleName?.toLowerCase() === 'vendor';
        console.log("---196-----isVendor-----", isVendor);
        if (isVendor) {
          if (loggedInPanNo) {
            console.log("---pan available--", loggedInPanNo);
            const vendorDetailsOfLoggedInPan = userDetails[0].vendorDetails.filter(//if user is mapped for multiple vendors, so filtering the vendor details of logged in panNo
              (vendor: any) => vendor.vendorPan === loggedInPanNo
            );
            console.log("vendorDetailsOfLoggedInPan******", vendorDetailsOfLoggedInPan);
            if (!vendorDetailsOfLoggedInPan || !vendorDetailsOfLoggedInPan?.length) {
              this.commonService.openSnackBar('Vendor details is not found. Please contact the Admin', 'Ok', 8000, 'warn-snackbar');
              return;
            }
            const hasCountry = vendorDetailsOfLoggedInPan?.every(
              (vendor: any) => vendor?.vendorCountry !== undefined && vendor.vendorCountry !== null && vendor.vendorCountry.trim() !== ''
            );
            console.log("---199, hascountry----", hasCountry);
            if (!hasCountry) {
              console.log("---15555---");
              this.commonService.openSnackBar('Country details is not available. Please contact the Admin', 'Ok', 8000, 'warn-snackbar');
              return;
            }
          } else {
            console.log("---pan not applicable-------");
            if (!userDetails[0]?.vendorDetails || !userDetails[0]?.vendorDetails?.length) {
              this.commonService.openSnackBar('Vendor details is not found. Please contact the Admin', 'Ok', 8000, 'warn-snackbar');
              return;
            }
            const hasCountry = userDetails[0]?.vendorDetails?.every(
              (vendor: any) => vendor?.vendorCountry !== undefined && vendor.vendorCountry !== null && vendor.vendorCountry.trim() !== ''
            );
            console.log("---199, hascountry----", hasCountry);
            if (!hasCountry) {
              console.log("---15555---");
              this.commonService.openSnackBar('Country details is not available. Please contact the Admin', 'Ok', 8000, 'warn-snackbar');
              return;
            }
          }
          this.redirectToApp(appDetails);
        } else {
          this.redirectToApp(appDetails);
        }
      });
    } else if (appName === 'Supplier Onboarding') {
      console.log("--SOB tile clicked-------");
      // const response: any = await this.openPoService.isEmailAvailable(localStorage.getItem("email") || '').pipe(take(1)).toPromise();//rxjs version 6 (pipe(take(1)).toPromise())
      // const isLoggedInEmailAvailableInSOBUserDetails = response?.data?.isEmailAvailable;
      const isLoggedInEmailAvailableInSOBUserDetails = true;
      console.log("isLoggedInEmailAvailableInSOBUserDetails---", isLoggedInEmailAvailableInSOBUserDetails);

      if (isLoggedInEmailAvailableInSOBUserDetails) {
        console.log("-----223-----user details available in sob");
        this.redirectToApp(appDetails);
      } else {
        this.showAccessDeniedSnackbar();
      }
    }
  }

  onMoreInfoClick(appDescription: string) {
    if (appDescription) {
      this.dialog.open(ApplicationDescriptionComponent, {
        height: '40%',
        width: '40%',
        data: {
          appDescription
        }
      });
    } else {
      this.snackBar.open('No description available for now!', 'Ok', {
        duration: 7000,
      });
    }
  }

  getITSMUrl() {
    this.openPoService.getConfigByType('ITSM_URL').subscribe((res: any) => {
      console.log("--res-", res);
      this.itsmUrl = res?.data?.getConfigByType?.value1;
    });
  }

  getAccessDeniedMsg() {
    this.openPoService.getConfigByType('ACCESS_DENIED_MSG').subscribe((res: any) => {
      console.log("--res-", res);
      this.accessDeniedMsg = res?.data?.getConfigByType?.value1;
    });
  }

  showAccessDeniedSnackbar() {
    const snackBarRef = this.snackBar.open(
      this.accessDeniedMsg,
      'Raise Ticket',
      { duration: 5000 }
    );
    snackBarRef.onAction().subscribe(() => {
      window.open(this.itsmUrl, '_blank');
    });
  }

  redirectToApp(appDetails:any) {
    window.open(appDetails?.applicationUrl, `_${appDetails?.applicationName.replace(/\s+/g, '')}`);
  }
  ngOnDestroy() {
    console.log("----on destroy----")
  }
}
